const colors = {
  BLUE_PRIMARY: '#4267B2', // callout blue
  BLUE_SECONDARY: '#5890ff', // contact blue
  WHITE: '#ffffff',

  GREY_NO_10: '#F6F7F9', // Ligtest bg color (behind media images)
  GREY_NO_20: '#CED0D4', // Mid-light bg color (bg for Intro)
  GREY_NO_30: '#E9EBEE', // Mid-Dark BG color under media
  GREY_NO_40: '#4b4f56', // header text
  GREY_NO_50: '#90949C', // description text
  GREY_NO_60: '#4B4F56', // category text
  GREY_NO_70: '#666E79', // navigation scrollbar
};

export default {
  ...colors,

  MID_DARK_BG: colors.GREY_NO_30,

  LINK_COLOR: colors.GREY_NO_40,
  LINK_HOVER_COLOR: colors.BLUE_PRIMARY,
};


// WEBPACK FOOTER //
// ./src/identity/colors.js